import theme from '@styles/theme';
export default {
  articleImage: {
    position: 'relative',
    width: ['78.6666667vw', '78.6666667vw', '41.40625vw', '25.7291667vw', '25.7291667vw', '25.7291667vw', '25.7291667vw', 494],
    height: ['78.6666667vw', '78.6666667vw', '41.40625vw', '25.7291667vw', '25.7291667vw', '25.7291667vw', '25.7291667vw', 494],
    img: {
      objectFit: 'cover'
    }
  },
  articleTitle: {
    fontSize: theme.fontSizes.text,
    mt: [16, 16, 16, 24],
    color: theme.rawColors.darkGrey700,
    maxWidth: ['78.6666667vw', '78.6666667vw', '41.40625vw', '25.7291667vw', '25.7291667vw', '25.7291667vw', '25.7291667vw', 494],
    display: 'block'
  }
};